// extracted by css-extract-rspack-plugin
export default {"root":"root-I6b5_Y","progress":"progress-rj4Zy1"};